function detectFingerMovement() {
  document.addEventListener('touchstart', handleTouchStart, false);
  document.addEventListener('touchmove', handleTouchMove, false);

  let xDown = null;
  let yDown = null;

  function handleTouchStart(evt) {
    xDown = evt.touches[0].clientX;
    yDown = evt.touches[0].clientY;
  }

  function handleTouchMove(evt) {
    if (!xDown || !yDown) {
      return;
    }

    let xUp = evt.touches[0].clientX;
    let yUp = evt.touches[0].clientY;

    let xDiff = xDown - xUp;
    let yDiff = yDown - yUp;

    if (Math.abs(xDiff) > Math.abs(yDiff)) {
      /*most significant*/
      if (xDiff > 0) {
        console.log('moved left');
      } else {
        console.log('moved right');
      }
    } else {
      if (yDiff > 0) {
        console.log('moved up');
      } else {
        console.log('moved down');
      }
    }
    /* reset values */
    xDown = null;
    yDown = null;
  }
}

let swipeDetector = { detectFingerMovement };

export default swipeDetector;
